import {Injectable} from "@angular/core";
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from "@shared/components/platform-tool/platform-tool-container/platform-tool-component";
import {FuseSplashScreenService} from "@barebone-fuse-services/splash-screen.service";
import {ParticleCacheService} from "@core/services/particle-cache.service";
import {PlatformCommand} from "@shared/commands/command-base";
import {CommandService} from '@core/services/command.service';
import {Dynamic_Grid_Data_Request_Parameters} from "@shared/store/actions/virtual-grid.actions";

@Injectable({
  providedIn: 'root',
})

export class ShowSelfRegisteredEatUsageReportHandler implements IPlatformCommandHandler {
  constructor(
    private fuseSplashScreenService: FuseSplashScreenService,
    private particleCacheService: ParticleCacheService,
    private commandService: CommandService,
  ) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const sourceType = handler.magicLinkModel.tabBar.tabs[0].tabData['SourceType'];
    const showSelfRegistered = command.isChecked;
    handler.magicLinkModel.tabBar.tabs[handler.magicLinkModel.tabBar.selectedIndex].tabData['SELF_REGISTERED'] = showSelfRegistered;
    const params = this.particleCacheService.getUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, sourceType);
    params['SELF_REGISTERED'] = command.isChecked;
    this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, sourceType, params);
    command["SELF_REGISTERED"] = command.isChecked;
    this.commandService.executePlatformCommand(command);
    handler.invalidateSubject.invalidate();
    this.fuseSplashScreenService.hide();
    return true;
  }
}
